import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class MxValidationService {
  constructor() { }

  static getValidatorError(code: string, validatorValue?: any) {
    let params;

    if (code === 'minlength') {
      params = [];
      params.push({ requiredLength: validatorValue.requiredLength });
    }

    return { message: code, params: params };
  }

  static creditCardValidator(control: AbstractControl) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    // tslint:disable-next-line
    if (
      control.value?.match(
        /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
      )
    ) {
      return null;
    } else {
      return { invalidCreditCard: true };
    }
  }

  static emailValidator(control: AbstractControl) {
    // RFC 2822 compliant regex
    // tslint:disable-next-line
    if (
      control.value?.match(
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i
      )
    ) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }

  static phoneValidator(control: AbstractControl) {
    if (
      control.value?.match(
        /^\+36(1|2[0-9]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\d{7,8}$/
      )
    ) {
      return null;
    } else {
      return { invalidPhoneNumber: true };
    }
  }

  static passwordValidator(control: AbstractControl) {
    const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&+\-.])[A-Za-z\d$@$!%*#?&+\-.]{8,}$/;
    const noAccentedLettersPattern = /^[^\u00C0-\u024F]*$/;

    if (control.value?.match(passwordPattern) && control.value?.match(noAccentedLettersPattern)) {
      return null;
    } else {
      return { invalidPassword: true };
    }
  }

  static acceptTermsValidator(control: AbstractControl) {
    if (
      control.value === true
    ) {
      return null;
    } else {
      return { invalidAcceptTerms: true };
    }
  }

  static passwordMustMatchValidator(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.passwordMustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ passwordMustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  static greaterThanDateValidator(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.greaterThanDate) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (moment(control.value).utc(true).seconds(0).milliseconds(0).isSameOrAfter(moment(matchingControl.value).utc(true).seconds(0).milliseconds(0))) {
        matchingControl.setErrors({ greaterThanDate: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
